


import { ISelectOption } from "../dtos/SelectOptionDto";
enum FraudTypeCodes {
        Item1 = 0,
        Item2 = 1,
        Item3 = 2,
        Item4 = 3,
        Item5 = 4,
         
}

export class FraudTypeCodes_class {

public static enum = FraudTypeCodes;

  public static readonly enumByText : { [key : string ]: number} = {
    ['Item1']: 0,
    ['Item2']: 1,
    ['Item3']: 2,
    ['Item4']: 3,
    ['Item5']: 4,
    
  };
  public static readonly enumByNumber : { [key : number ]: string} = {
    [0]: "1- Potential identity theft",
    [1]: "2- Claimant still working",
    [2]: "3- Claimant deceased",
    [3]: "4- Claimant incarcerated",
    [4]: "5- Not listed above",
    
  };

  public static readonly enumAsSelectOptions:Array<ISelectOption<number>> = [
  {value: 0, text: "1- Potential identity theft"},
  {value: 1, text: "2- Claimant still working"},
  {value: 2, text: "3- Claimant deceased"},
  {value: 3, text: "4- Claimant incarcerated"},
  {value: 4, text: "5- Not listed above"},
  ]
}

